export default __webpack_public_path__ + "static/media/kit_3.27447762.png";